import { render, staticRenderFns } from "./PageNumberUnderlyingShape.vue?vue&type=template&id=4811645a&scoped=true"
import script from "./PageNumberUnderlyingShape.vue?vue&type=script&lang=js"
export * from "./PageNumberUnderlyingShape.vue?vue&type=script&lang=js"
import style0 from "./PageNumberUnderlyingShape.vue?vue&type=style&index=0&id=4811645a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811645a",
  null
  
)

export default component.exports